<template>
    <div
        ref="scroller"
        :style="wrapStyles"
        :class="containerCls"
        @scroll="handleScroll"
    >
        <div ref="phantom" :class="phantomCls" :style="{ height: contentHeight }"></div>
        <div v-if="visibleData && visibleData.length > 0" ref="content" :class="contentCls" :style="{ minWidth: treeOptions.width + 'px', transform: `translateY(${offset}px)` }">
            <div
                :class="itemCls"
                ref="items"
                :id="item._index"
                :key="item._index"
                v-for="item in visibleData">
                <div v-if="renderNode(item)">{{renderNode(item)}}</div>
                <div v-else>
                    <div v-if="item.visible" :class="treeNodeCls">
                        <span v-if="item.level - 1 > 0" :style="{minWidth: (item.level - 1) * 14 + 'px'}">
                          <span v-for="(node, index) in (item.level - 1)" :class="lineClasses(item, index)"></span>
                        </span>
                        <span :class="arrowClasses(item)" @click="toggleExpand(item)">
                            <Icon v-if="item.children && item.children.length" :type="item.expand ? 'iconbj_off' : 'iconbj_on'" ></Icon>
                            <Icon v-else type="md-copy" />
                        </span>
                        <label v-if="treeOptions.showCheckbox" style="margin-left: 10px">
                            <Checkbox
                                :value="item.checked"
                                :disabled="item.disabled"
                                :indeterminate="item.indeterminate"
                                @click.native.prevent="handleCheck(item)"
                            ></Checkbox>
                        </label>
                        <span
                            v-if="treeOpt.treeRender"
                            :class="nodeCls"
                            :style="nodeSty(item)"
                            @click="titleClick(item)"
                        >{{treeOpt.treeRender(item) || ''}}</span>
                        <span
                            v-else
                            :class="nodeCls"
                            :style="nodeSty(item)"
                            @click="titleClick(item)"
                        >{{item[renderTitle] || ''}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else :class="emptyCls">{{emptyText}}</div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
import burgeonConfig from '../../assets/config';
import Icon from '../icon/icon.vue';

const prefixCls = `${burgeonConfig.prefixCls}virtual-list`;
let lastTime = 0;

const flatten = function(
    list,
    childKey = 'children',
    level = 1,
    parent = null,
    defaultExpand = false,
    checked = false,
    indeterminate = false,
    defaultChecked,
    keygen,
    query = false,
    checkedKey = 'checked'
) {
    let arr = [];
    if (!list || Object.prototype.toString.call(list) !== '[object Array]') return [];
    list.forEach(item => {
        if (!item) item = {};
        item.level = level;
        if (level !== 1) {
            item.parent = parent;
        }
        item.query = false;
        item.children = childKey ? item[childKey] : [];

        if (defaultChecked && defaultChecked.length > 0) {
            item.checked = defaultChecked.indexOf(item[keygen]) > -1;
        } else if (!defaultChecked || defaultChecked.length === 0) {
            item.checked = item[checkedKey];
        } else {
            item.checked = false;
        }

        item.indeterminate = item[childKey] && item[childKey].some(v => v[checkedKey]) && !item[childKey].every(v => v[checkedKey]);
        if (item.expand === undefined) {
            item.expand = defaultExpand;
        }
        if (item.visible === undefined) {
            item.visible = true;
        }
        if (!parent.visible || !parent.expand) {
            item.visible = false;
        }
        // item.children = item[childKey] && item[childKey].map((v, i) => ({ ...v, last: i === item.children.length - 1 }))
        arr.push(item);
        if (item[childKey]) {
            arr.push(
                ...flatten(
                    item[childKey],
                    childKey,
                    level + 1,
                    item,
                    defaultExpand,
                    checked,
                    indeterminate,
                    defaultChecked,
                    keygen,
                    query,
                    checkedKey
                )
            );
        }
    });
    // console.log('arr', arr)
    return arr;
};


export default {
    name: 'VirtualList',
    components: { Icon },
    props: {
        height: {
            type: [String, Number]
        },
        //唯一键
        keygen: {
            type: String,
            default: 'key'
        },
        childKey: {
            type: String,
            default: 'children'
        },
        renderTitle: {
            type: String,
            default: 'title'
        },
        emptyText: {
            type: String,
            default: '暂无数据'
        },
        //渲染
        renderItem: {
            type: String | Function,
            default: ''
        },
        //所有列表数据
        listData: {
            type: Array | Function,
            default: () => []
        },
        timeout: { //刷新频率
            type: Number,
            default: 17
        },
        // option: {
        //     // 配置对象
        //     type: Object,
        //     default() {
        //         return {
        //             width: 300, //滚动容器的宽度
        //             height: 500, //滚动容器的高度
        //             itemHeight: 25 // 单个item的高度
        //         };
        //     }
        // },
        treeOpt: {
            type: Object,
            default: () => ({
                width: 300, //滚动容器的宽度
                height: 500, //滚动容器的高度
                itemHeight: 25, // 单个item的高度
                showCheckbox: false,
                line: false,
                nodeInteraction: true,
                treeRender: () => {},
                mode: 0,
                checkedKey: 'checked',
                checked: []
            })
        }
    },
    computed: {
        classes() {
            return `${prefixCls}`;
        },
        wrapStyles() {
            return Object.assign({}, { overflowX: 'auto' }, { height: '100%' });
        },
        containerCls() {
            return `${prefixCls}-container`;
        },
        phantomCls() {
            return `${prefixCls}-phantom`;
        },
        contentCls() {
            return `${prefixCls}-content`;
        },
        itemCls() {
            return `${prefixCls}-item`;
        },
        treeNodeCls() {
            return this.treeOpt.line ? `${prefixCls}-tree-node-with-line` : `${prefixCls}-tree-node`;
        },
        nodeCls() {
            return `${prefixCls}-node`;
        },
        emptyCls() {
            return `${prefixCls}-empty`;
        },
        arrowClasses () {
          return function(item) { return this.treeOpt.line ? `${prefixCls}-arrow-with-line` : `${prefixCls}-arrow`;}
        },
        lineClasses () {
            return function (item, index) {
                return [
                    'line',
                    { 'lastNode': item.last && index + 1 === item.level - 1 }
                ];
            };
        },
        // visibleCount() {
        //     return Math.floor(this.treeOpt.height / this.treeOpt.itemHeight);
        // },
        treeOptions() {
            return Object.assign({}, { nodeInteraction: true, mode: 0 }, { width: 300, height: 500, itemHeight: 25 }, this.treeOpt);
        }
    },
    // created() {
    //     this.localListData = JSON.parse(JSON.stringify(this.listData));
    // },
    created() {
        this.watchScroll = debounce(this.handleScroll, 500, {leading: false});
    },
    mounted() {
        this.update();
        // console.log('this.treeOptions', this.treeOptions)
        // console.log('Math.floor(this.treeOptions.height / this.treeOptions.itemHeight)', Math.floor(this.treeOptions.height / this.treeOptions.itemHeight))
    },
    watch: {
        localListData: {
            handler (newV) {
                this.updateView('change');
            },
            immediate: true,
            deep:true
        },
        listData: {
            handler (newV, old) {
                // console.log('old-listData', old)
                // console.log('newV-listData', newV)
                this.localListData = [];
                this.update();
            },
            immediate: true,
            deep:true
        },
        'treeOpt.checked': {
            handler (newVal, oldVal) {
                if (newVal && oldVal && newVal.length !== oldVal.length) {
                    this.update();
                }
            },
            immediate: true,
            deep:true
        }
    },
    data() {
        return {
            offset: 0, // translateY偏移量
            contentHeight: '0px',
            visibleCount: 0,
            // 组件内部数据
            visibleData: [],
            localListData: [],
            findVal: '',
            watchScroll: null
        };
    },
    methods: {
        getContentHeight() {
            this.contentHeight = `${(this.localListData || []).filter(item => item.visible).length * this.treeOptions.itemHeight}px`;
        },
        updateView(type) {
            this.getContentHeight();
            this.$emit('update', this.listData);
            this.handleScroll('e', type);
        },
        handleScroll(e, type) {
            let currentTime = Number(new Date());
            if (currentTime - lastTime > this.timeout) {
                const scrollTo = type ? 0 : this.$refs.scroller && this.$refs.scroller.scrollTop;
                this.updateVisibleData(scrollTo);
                if (type && this.$refs.scroller) {
                    this.$refs.scroller.scrollTop = 0;
                }
                lastTime = currentTime;
            }
        },
        updateVisibleData(scrollTop = 0) {
            // console.log('updateVisibleData----this.localListData', this.localListData)
            // console.log('updateVisibleData----visible', this.localListData.filter(item => item.visible))
            let start = Math.floor(scrollTop / this.treeOptions.itemHeight) - Math.floor(this.visibleCount / 2);
            start = start < 0 ? 0 : start;
            this.visibleCount = Math.floor(this.treeOptions.height / this.treeOptions.itemHeight);
            const end = start + this.visibleCount * 2;
            const filterData = this.localListData.filter(item => item.visible);
            // console.log('this.visibleData', this.visibleData)
            this.visibleData = filterData.slice(start, end);
            // this.visibleData = this.visibleData.shift().push(filterData.slice(end - 1, end));
            this.offset = start * this.treeOptions.itemHeight;
            // console.log('updateVisibleData--触发this.visibleData', this.visibleData)
        },
        // 获取本地拍平数据
        handleFlattenTree(arr, treeOptions) {
            const { keygen } = this;
            const { checked, checkedKey } = treeOptions;
            // console.log('treeOptions', treeOptions)
            return flatten(arr, this.childKey, 1, {
                level: 0,
                visible: true,
                expand: true,
                children: this.listData
            }, false, false, false, checked, keygen, '', checkedKey);
        },
        update() {
            // console.log('this.listData-1', this.listData)
            // console.log('this.treeOptions', this.treeOptions)
            // console.log('this.listData', this.listData)
            this.localListData = [...this.handleFlattenTree(this.listData, this.treeOptions)];
            // console.log('this.localListData----update', this.localListData)
        },

        renderNode(data) {
            const {renderItem} = this;
            if (renderItem) {
                const render = typeof renderItem === 'function' ? renderItem : d => d[renderItem];
                return render(data);
            }
            return false;
        },
        titleClick(item) {
            if (this.treeOptions.showCheckbox) {
                this.handleCheck(item);
                return;
            }
            this.singleCheck(item);
        },
        nodeSty(item) {
            const str = item[this.renderTitle || 'title'];
            const title = this.findVal && str && str.toLowerCase().indexOf(this.findVal) > -1 ? {color: '#e80707'} : {};
            const bgc = item.checked && !this.treeOpt.showCheckbox ? {backgroundColor: '#2d8cf04d'} : {};
            return Object.assign({}, title, bgc);
        },
        // 节点点击
        toggleExpand(item) {
            const isExpand = item.expand;
            if (isExpand) {
                this.collapse(item, true); // 折叠
            } else {
                this.expand(item, true); // 展开
            }
            this.updateView();
        },
        //展开节点
        expand(item) {
            if (item.children) {
                item.expand = true;
                this.recursionVisible(item.children, true);
            }
        },
        //折叠节点
        collapse(item) {
            if (item.children) {
                item.expand = false;
                this.recursionVisible(item.children, false);
            }
        },
        //折叠所有
        collapseAll(level = 1) {
            this.localListData.forEach(item => {
                item.expand = false;
                item.visible = item.level === level;
            });
            // console.log('this.localListData', this.localListData)

            this.updateView('collapseAll');
        },
        //展开所有
        expandAll() {
            this.localListData.forEach(item => {
                item.expand = true;
                item.visible = true;
            });
            this.updateView('expandAll');
        },
        //展开所有
        checkAll() {
            this.localListData.forEach(item => {
                item.checked = true;
                item.indeterminate = false;
            });
            let checkedList = this.localListData.filter(v => v.checked);
            this.updateView('checkAll');
            this.onCheckChange(checkedList);
        },
        //清除所有
        clearAll(level = 1) {
            // console.log('clearAll')
            // const { keygen } = this;
            // const { checked: defaultChecked, checkedKey } = this.treeOptions;
            this.localListData.forEach(item => {
                item.checked = false;
                item.indeterminate = false;
            });
            this.updateView('clearAll');
            this.onCheckChange([]);
        },
        showAll(type) {
            type ? this.expandAll() : this.collapseAll();
        },
        //递归节点
        recursionVisible(children, status) {
            children.forEach(node => {
                node.visible = status;
                if (node.children && !status) {
                    node.expand = status;
                    this.recursionVisible(node.children, status);
                }
            });
        },
        // 单选
        singleCheck(item) {
            // 清除其他选项
            this.localListData = [...this.handleFlattenTree(this.listData, Object.assign({}, this.treeOptions, { checked: []}))]
            // 选中当前点击
            if (!item) {
                this.updateView('collapseAll')
                return;
            }
            if (item.indeterminate) {
                item.indeterminate = false;
            }
            item.checked = !item.checked;
            this.updateView();
            // 抛出事件
            let checkedList = this.localListData.filter(v => v.checked);
            this.onCheckChange(checkedList, item);
        },
        // 勾选
        handleCheck(item) {
            if (!item) {
                this.updateView('collapseAll')
                return;
            }
            if (item.indeterminate) {
                item.indeterminate = false;
            }
            item.checked = !item.checked;
            if (item.children) {
                this.checkedChild(item.children, item.checked);
            }
            if (this.treeOptions.nodeInteraction) {
                // 父子节点向上联动
                this.updateParent(item, item.checked);
            }
            this.updateView();

            let checked = [];
            let checkedList = this.localListData.filter(v => v.checked);
            // mode 0: full  1: child only  ##2: parent only
            if (this.treeOptions.mode === 0) {
                checked = checkedList;
            } else if (this.treeOptions.mode === 1) {
                // 获取当前节点的子节点，在flattenTree中过滤掉
                checked = this.getChildNode(checkedList);
            } else {
                checked = this.getChildNode(checkedList);
            }
            // console.log('handleCheck', checked, item)
            this.onCheckChange(checked, item);
        },
        checkedChild(children, status) {
            children.forEach(node => {
                node.checked = status;
                if (node.indeterminate) {
                    node.indeterminate = false;
                }
                if (node.children) {
                    this.checkedChild(node.children, status);
                }
            });
        },
        // 父子节点向上联动
        updateParent(node, check) {
            if (node.parent) {
                // 判断父节点的所有子节点的选中状态
                const allChecked = node.parent.children.every(item => item.checked);
                const someChecked = node.parent.children.some(item => item.checked || item.indeterminate);
                if (check) {
                    node.parent.checked = allChecked;
                    node.parent.indeterminate = !node.parent.checked;
                } else {
                    node.parent.checked = false;
                    node.parent.indeterminate = someChecked;
                }
                if (node.parent.parent) {
                    this.updateParent(node.parent, check);
                }
            }
        },
        // 获取当前节点的子节点，在flattenTree中过滤掉
        getChildNode(checkedList) {
            return checkedList.reduce((prev, cur) => {
                !cur.children && prev.push(cur);
                return prev;
            },[]);
        },

        // emit-[on-check-change]
        onCheckChange(checked, node) {
            this.$emit('on-check-change', checked, node);
        },

        query(val) {
            if (!val) {
                this.findVal = '';
                this.clearAll();
            } else {
                let queryKey = val.trim();
                this.findVal = queryKey;
                this.expandAll();
                const has = this.localListData && this.localListData.some(v => v[this.renderTitle || 'title'] && v[this.renderTitle || 'title'].indexOf(queryKey) > -1);
                this.$emit('on-query-cbk', has, queryKey);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/virtual-list/virtual-list.vue